import { MainMapTypes } from '@enums/MainMapTypes'

export enum ApiModule {
  METEO = 'METEO',
  INCENDIOS = 'INCENDIOS'
}

export namespace ApiModule {
  export function fromMainMapType(type: MainMapTypes) {
    switch (type) {
      case MainMapTypes.METEO:
        return ApiModule.METEO
      case MainMapTypes.INCENDIOS:
        return ApiModule.INCENDIOS
      default:
        throw new Error('Unknown api module')
    }
  }
}
